export default "__VITE_ASSET__S4PZUPCn__"